export function getInitials(value: string) {
  const parts = value.split(/\s+/).filter(Boolean).slice(0, 2)
  if (parts.length === 0) return 'KL'
  return parts.map((part) => part.charAt(0).toUpperCase()).join('')
}

export function timeAgo(value: string | number | Date) {
  const date = value instanceof Date ? value : new Date(value)
  const delta = Date.now() - date.getTime()
  const minutes = Math.round(delta / 60000)

  if (Number.isNaN(date.getTime())) return 'unknown'
  if (minutes < 1) return 'just now'
  if (minutes < 60) return `${minutes}m ago`

  const hours = Math.round(minutes / 60)
  if (hours < 24) return `${hours}h ago`

  const days = Math.round(hours / 24)
  if (days < 30) return `${days}d ago`

  return date.toLocaleDateString()
}

export function formatDate(value: string | number | Date) {
  const date = value instanceof Date ? value : new Date(value)
  if (Number.isNaN(date.getTime())) return 'Unknown'
  return date.toLocaleDateString()
}

export function shortSha(sha: string) {
  return sha.slice(0, 7)
}

export function shortId(value: string) {
  return value.length > 12 ? value.slice(0, 8) : value
}

export function formatBytes(bytes: number) {
  if (!Number.isFinite(bytes) || bytes < 0) return '0 B'
  if (bytes < 1024) return `${bytes} B`
  if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(1)} KB`
  if (bytes < 1024 * 1024 * 1024) return `${(bytes / (1024 * 1024)).toFixed(1)} MB`
  return `${(bytes / (1024 * 1024 * 1024)).toFixed(1)} GB`
}
